import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {SnackbarProvider} from "notistack";
import {AuthContextProvider} from "./allauth/auth";
import {AssessmentProvider} from "./context/AssessmentContext";
import {NativeWebViewInsetsProvider} from "./context/NativeWebViewInsetsContext";
import ExternalPurchaseDisclosureDialog from "./components/ExternalPurchaseDisclosureDialog";
import NativeCheckoutReturnHandler from "./components/NativeCheckoutReturnHandler";
import {PointsProvider} from "./context/PointsContext";
import {NavDrawerProvider} from "./NavDrawerProvider";
import Router from "./Router";
import {ThemeProvider} from "./theme/ThemeContext";

export default function App() {
    return (
        <ThemeProvider>
            <NativeWebViewInsetsProvider>
                <ExternalPurchaseDisclosureDialog />
                <NativeCheckoutReturnHandler />
                <SnackbarProvider
                    maxSnack={4}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center"
                    }}
                >
                    <AuthContextProvider>
                        <PointsProvider>
                            <NavDrawerProvider>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <AssessmentProvider>
                                        <Router/>
                                    </AssessmentProvider>
                                </LocalizationProvider>
                            </NavDrawerProvider>
                        </PointsProvider>
                    </AuthContextProvider>
                </SnackbarProvider>
            </NativeWebViewInsetsProvider>
        </ThemeProvider>
    );
}
